import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { QueryFunction, useQuery } from '@tanstack/react-query';

export const EENHEDEN_INREGELING_STATUS_QUERY_KEY = ['geefAlleEenhedenInregelingStatus'];

export interface EenheidInregelingStatusResponse {
  nummer: string;
  inregeling?: {
    afspraakId?: string | null;
    uitlooplocatie?: string | null;
  } | null;
}

// Lenient on purpose: Agenda shares this query, so one malformed unit must not drop every inregeling lock.
const isEenheidInregelingStatus = (value: unknown): value is EenheidInregelingStatusResponse =>
  typeof value === 'object' &&
  value !== null &&
  'nummer' in value &&
  typeof value.nummer === 'string' &&
  'inregeling' in value;

const useGetEenhedenInregelingStatus = (enabled = true) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<EenheidInregelingStatusResponse[]> = async () => {
    const response = await fetchWithAuth('/eenheid/v1/geefAlleEenhedenInregelingStatus');
    throwIfResponseNotOk(response, `Ophalen van eenheden inregeling status is mislukt (${response.status}).`);
    const data: unknown = await response.json();
    return Array.isArray(data) ? data.filter(isEenheidInregelingStatus) : [];
  };

  return useQuery({
    queryKey: EENHEDEN_INREGELING_STATUS_QUERY_KEY,
    queryFn: fetcher,
    enabled,
    refetchInterval: 30_000,
    meta: managedPageQueryMeta,
  });
};

export default useGetEenhedenInregelingStatus;
